import React from 'react'

import NavbarBrand from './navbar-brand'
import NavbarLink from './navbar-link'
import NavbarSocial from './navbar-social'
import NavbarToggler from './navbar-toggler'

const Navbar = () => {
  return (
    <nav className='navbar navbar-expand-lg navbar-dark bg-danger fixed-top shadow'>
      <NavbarBrand />

      <NavbarToggler target='navbarNav' />

      <div className='collapse navbar-collapse' id='navbarNav'>
        <div className='navbar-nav mr-auto'>
          <NavbarLink to='/news/'>News</NavbarLink>
          <NavbarLink to='/events/'>Events</NavbarLink>
          <a href='https://hotpots.tmstor.es/' className='nav-item nav-link'>
            Shop
          </a>
        </div>

        <NavbarSocial />
      </div>
    </nav>
  )
}

export default Navbar
